<template>
  <modal titulo="Alterar texto do ato" id="comparacao-texto" :loading="loadingImagens" loadingTxt="Carregando imagens...">
    <div class="row gutters-xs">

      <div class="col">
        <card titulo="Original">
          <card-content>
            <v-input v-model="original"
                     :disabled="true"
                     type="readonly-editor" />
          </card-content>
        </card>
      </div>

      <div class="col">
        <card titulo="Novo">
          <card-content>
            <v-input v-model="novo"
                     :disabled="true"
                     type="readonly-editor" />
          </card-content>
        </card>
      </div>

      <div class="col-12">
        <card titulo="Alterações">
          <card-content>
            <div v-html="changes" class="texto-legado"></div>
          </card-content>
        </card>
      </div>

    </div>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-auto">Cancelar</button>
      <button type="button" @click.prevent="confirmar()" class="btn btn-outline-primary">Confirmar Alteração</button>
    </template>

  </modal>
</template>

<script>
import FrontBusiness from "@/business/FrontBusiness.js";
import Utils from "@/commons/Utils.js";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import Modal from "@/components/Modal.vue";
import Diff from 'text-diff';

export default {
  name: "ModalCompararTexto",
  components: {CardContent, Card, Modal},
  props: {
    original: String,
    novo: String
  },

  modal: {
    width: 1100
  },

  data(){
    return {
      changes: '',
      loadingImagens: false
    }
  },

  mounted() {
    this.load();
    this.rastrearImagens();
  },

  methods:{

    // Aquece as digitalizações comprimidas antes de mostrar o diff — a compressão acontece no
    // servidor e a primeira leitura é lenta. Duas formas convivem no acervo: a legada
    // (/api/anexo/public/{id}/download/compress) e a autenticada (/api/imagem-texto/{id}/compress),
    // por isso o casamento é pelo /compress e não pelo prefixo.
    rastrearImagens() {
      if (!this.novo || !this.novo.includes('/compress')) return;
      const regex = /src="([^"]*\/compress[^"]*)"/g;
      const urls = [];
      let match;
      while ((match = regex.exec(this.novo)) !== null) {
        urls.push(match[1]);
      }
      if (!urls.length) return;
      this.loadingImagens = true;
      Promise.all(urls.map(url => new Promise(resolve => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = resolve;
        img.src = url;
      }))).finally(() => {
        this.loadingImagens = false;
      });
    },

    load(){
      const diff = new Diff();
      const textDiff = diff.main(Utils.removeHTML(this.original), Utils.removeHTML(this.novo));
      this.changes = diff.prettyHtml(textDiff);
    },

    close() {
      FrontBusiness.closeModal(false);
    },

    confirmar() {
      FrontBusiness.closeModal(true);
    },

  }

}
</script>

<style lang="css">
#comparacao-texto .texto-legado del{
  background: #FF8585FF !important;
  color: black;
  text-decoration: line-through;
}
#comparacao-texto .texto-legado ins{
  background: #A2FAA2FF !important;
  color: black;
}
</style>
